import template   from './help-block.html'
import controller from './help-block.controller'
import './help-block.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/help-block/help-block.component.js